import React, {CSSProperties, useState, useEffect} from 'react';
import CancelButtonEditor from '../cancelButtonEditor/cancelButtonEditor';
import './headerCatalogerResource.scss'
import { useTranslation } from 'react-i18next';
import { IQuestionEditorState, IQuestionEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import QuestionsNavigator from '../questionsNavigator/questionsNavigator';
import QuestionsService from 'app_services/editor/questions/questionsService';

export interface HeaderCatalogerResourceProps {
  title?: string
  className?: string
  style?: CSSProperties
  hideCancelButton?: boolean
  hideFinishButton?: boolean
  showQuestionNavigator?: boolean
  questions?: IQuestionEditorState[] | IQuestionEditor[]
  currentQuestion?: IQuestionEditorState | IQuestionEditor
  onClickCancel?: ()=>void
  onClickFinish?: ()=>void
  onChangeQuestion?: (question: IQuestionEditorState | IQuestionEditor) => any
}

const HeaderCatalogerResource: React.SFC<HeaderCatalogerResourceProps> = (props) => {

  const {t} = useTranslation()
  // Servicios
  const questionsService = new QuestionsService()

  const handleOnChangeQuestion = async (question: IQuestionEditorState | IQuestionEditor) => {
    if(props.onChangeQuestion){
      const status = await questionsService.validateChangeQuestion()
      if(status){
        props.onChangeQuestion({...question})
      }
    }
  }

  return (
    <div
      className={`header_cataloger_resource-editor ${props.className ? props.className : ''}`}
      style={props.style}
    >
      <div className="container-title">
        <p>
          {props.title ? props.title : ''}
        </p>
      </div>
      <div className="container-buttons">
        {props.showQuestionNavigator && props.questions?.length && props.currentQuestion ?
          <QuestionsNavigator
            questions={props.questions}
            currentQuestion={props.currentQuestion}
            onChangeQuestion={handleOnChangeQuestion}
          />
        :null}
        {!props.hideCancelButton ?
        <CancelButtonEditor
          onClick={props.onClickCancel}
          className='btn-edit'
        >
            {/* <MdCancel className='icon-edit-button' /> */}
            {t('editor.resources.cancel')}
        </CancelButtonEditor>: null}
        {!props.hideFinishButton ?
        <CancelButtonEditor
          onClick={props.onClickFinish}
          className='btn-edit'
          style={{backgroundColor: 'var(--primary)', marginLeft: '10px'}}
        >
            {t('editor.resources.finish')}
        </CancelButtonEditor>: null}
      </div>
    </div>
  );
}

export default HeaderCatalogerResource;
